import Axios from 'axios';
import { getEndpointURL } from './config';
Axios.defaults.withCredentials = true;

const endpointURL = getEndpointURL();
const headers = { 'Content-Type': 'application/json; charset=utf-8' };

const GetUsers = async (searchUser, rowsPerPage, page) => {
    return Axios({
        method: 'POST',
        headers,
        data: { searchUser, rowsPerPage, page },
        url: `${endpointURL}/api/users/get-users`
    })
}

const CreateNewUser = async (userInfor) => {
    return Axios({
        method: 'POST',
        headers,
        data: { userInfor },
        url: `${endpointURL}/api/users/create-new-user`
    })
}

const UpdateUser = async (userInfor) => {
    return Axios({
        method: 'POST',
        headers,
        data: { userInfor },
        url: `${endpointURL}/api/users/update-user`
    })
}

const InactiveUser = async (selected) => {
    return Axios({
        method: 'POST',
        headers,
        data: { selected },
        url: `${endpointURL}/api/users/inactive-user`
    })
}
const ActiveUser = async (selected) => {
    return Axios({
        method: 'POST',
        headers,
        data: { selected },
        url: `${endpointURL}/api/users/active-user`
    })
}
const DeleteUser = async (selected) => {
    return Axios({
        method: 'POST',
        headers,
        data: { selected },
        url: `${endpointURL}/api/users/delete-user`
    })
}
const GetCompanies = async () => {
    return Axios({
        method: 'POST',
        headers,
        url: `${endpointURL}/api/users/get-companies`
    })
}

export {
    GetUsers,
    CreateNewUser,
    UpdateUser,
    InactiveUser,
    ActiveUser,
    DeleteUser,
    GetCompanies,
};
